import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { getErpJwtToken } from 'app/services/auth/erp-auth-token.util';
import { ensureHttpsUrl, isSafeToAttachAuthToken } from './ssl-auth.util';

/**
 * Ajoute Authorization: Bearer <jwt_erp> sur les appels gateway ERP
 * uniquement via HTTPS (ou localhost en dev).
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let req = request;
    const secureUrl = ensureHttpsUrl(req.url);
    if (secureUrl !== req.url) {
      console.warn('[JwtInterceptor] upgrade HTTP → HTTPS', req.url, '→', secureUrl);
      req = req.clone({ url: secureUrl });
    }

    const token = getErpJwtToken();
    if (!token) {
      return next.handle(req);
    }

    if (!isSafeToAttachAuthToken(req.url)) {
      console.error(
        '[JwtInterceptor] JWT non attaché : URL non sécurisée (SSL requis)',
        req.url
      );
      return next.handle(req);
    }

    const apiBase = ensureHttpsUrl(String(environment.apiUrl || '').replace(/\/$/, ''));
    const isGatewayUrl = apiBase.length > 0 && req.url.startsWith(apiBase);
    const parametrageUrl = (environment as { parametrage_url?: string }).parametrage_url;
    const paramBase = parametrageUrl
      ? ensureHttpsUrl(String(parametrageUrl).replace(/\/$/, ''))
      : '';
    const isParametrageUrl = paramBase.length > 0 && req.url.startsWith(paramBase);

    if (isGatewayUrl || isParametrageUrl) {
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(req);
  }
}
